import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Box, Button, Spinner, Text, useToast } from "@chakra-ui/react";
import API from "../../helpers/axiosInstance";


const TextTemplate = ({ id, customer }) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [saving, setSaving] = useState(false);

    const getApiHeaders = () => ({
        "x-access-token": localStorage.getItem("user"),
    });

    // Fetch available templates
    const fetchTemplates = async () => {
        setLoading(true);
        try {
            const res = await API.get(
                `${process.env.REACT_APP_API_URL}/template/msg-temp-type-ids?customer_id=${id}`,
                { headers: getApiHeaders() }
            );

            // Convert response into React Select options
            const options = (res.data.data || []).map((t) => ({
                value: t.id,
                label: t.name,
                message: t.message, // optional for preview
            }));
            setTemplates(options);
        } catch (err) {
            console.error(err);
            toast({
                title: "Failed to load templates",
                status: "error",
                duration: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) fetchTemplates();
    }, [id]);

    useEffect(() => {
        if (customer?.text_template_id && templates.length > 0) {
          const foundTemplate = templates.find(
            (t) => t.value === customer.text_template_id
          );
          if (foundTemplate) {
            setSelectedTemplate(foundTemplate);
          }
        }
      }, [customer, templates]);
      
    // Save selected template
    const handleSave = async () => {
        if (!selectedTemplate) {
            toast({
                title: "Please select a template first",
                status: "warning",
                duration: 2000,
            });
            return;
        }

        setSaving(true);
        try {
            await API.post(
                `${process.env.REACT_APP_API_URL}/customer/text-template`,
                {
                    id: Number(id),
                    text_template_id: selectedTemplate.value,
                },
                { headers: getApiHeaders() }
            );

            toast({
                title: "Template linked successfully!",
                status: "success",
                duration: 3000,
            });
        } catch (err) {
            console.error(err);
            toast({
                title: "Failed to save template",
                status: "error",
                duration: 3000,
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <Box m={4}>
            {loading ? (
                <Spinner />
            ) :
                <>
                    <Box w={"50%"}>
                        <Text fontSize={"md"} mb={2}>Select Template</Text>
                        <Select
                            options={templates}
                            placeholder="Select a text template"
                            value={selectedTemplate}
                            onChange={setSelectedTemplate}
                            isClearable
                        />
                    </Box>


                    <Button
                        mt={4}
                        colorScheme="blue"

                        size={"sm"}
                        onClick={handleSave}
                        isLoading={saving}
                        isDisabled={!selectedTemplate}
                    >
                        Save Template
                    </Button>

                    {selectedTemplate && (
                        <Box mt={4} p={3} border="1px solid #ddd" borderRadius="md" bg="gray.50">
                            <strong>Preview:</strong>
                            <div>{selectedTemplate.message}</div>
                        </Box>
                    )}
                </>}
        </Box>
    );
};

export default TextTemplate;
